import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";

import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import DeleteButton from "../../components/Form/DeleteButton";
import FilterForm from "../../components/Form/FilterForm";

import {
    withPaginator,
    Pagination
} from '../../components/Pagination';

const AttributeGroupIndex = ({classes, items, filter}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('attribute.group.title')}
            items={[
                {
                    icon: 'add',
                    text: i18n.get('attribute.group.add'),
                    href: '/attribute-groups/create',
                }
            ]}
        >
            <FilterForm
                url="/attribute-groups"
                filter={filter}
                inputPlaceholder={i18n.get('attribute.form.search_value')}
                buttonTitle={i18n.get('attribute.form.search')}
            />
        </Toolbar>

        <Paper className={classes.paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell scope="col">{i18n.get('attribute.group.form.name')}</TableCell>
                        <TableCell scope="col">{i18n.get('attribute.group.form.actions')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items.map(attributeGroup => (
                        <TableRow key={attributeGroup.id}>
                            <TableCell>
                                {attributeGroup.name}
                                {attributeGroup.parent && (
                                    <Typography component={"small"} variant={"subtitle2"}>
                                        {attributeGroup.parent.name_chain}
                                    </Typography>
                                )}
                            </TableCell>
                            <TableCell>
                                <IconButton
                                    component="a"
                                    href={`/attribute-groups/${attributeGroup.id}/edit`}
                                >
                                    <Icon>edit</Icon>
                                </IconButton>

                                <DeleteButton
                                    confirmMessage={i18n.get('attribute.group.delete.confirm')}
                                    successMessage={i18n.get('attribute.group.delete.success')}
                                    errorMessage={i18n.get('attribute.group.delete.error')}
                                    href={`/attribute-groups/${attributeGroup.id}`}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>

                <Pagination colSpan={2}/>
            </Table>
        </Paper>
    </Layout>
);

const styles = theme => ({
    paper: {
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(
    withPaginator('attributeGroups')(AttributeGroupIndex)
);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/attributeGroup/Index.jsx